import axios from 'axios';
const { VUE_APP_SERVER_BASE_URL: BASE_URL } = process.env;

const initialState = {
  status: '',
  initializing: false,
  token: '',
  message: '',
  currentUser: {},
};

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login: ({ commit, dispatch }, user) => {
      commit('AUTH_REQUEST');
      return new Promise((resolve, reject) => {
        axios
          .post(`${BASE_URL}/authentication/sign-in`, user)
          .then((res) => {
            const { token } = res.data.data;
            console.log(token);
            commit('AUTH_SUCCESS', token);
            dispatch('setCurrentUser');
            localStorage.setItem('token', token);
            axios.defaults.headers.common['Authorization'] = token;
            let role = JSON.parse(atob(token.split('.')[1])).role;
            resolve(role);
          })
          .catch((err) => {
            let msg = null;
            const { status } = err.response || {};
            if (status === 400) {
              msg = 'Incorrect Phone number or Password.';
            } else msg = err.message || 'An error occured please refresh.';

            commit('AUTH_ERROR', {
              message: err.response?.data || { message: msg },
            });
            localStorage.removeItem('token');
            dispatch('alert/error', msg, { root: true });
            return reject(err);
          });
      });
    },
    setCurrentUser: ({ commit, state, dispatch }) => {
      commit('APP_INITIALIZING', true);
      axios
        .get(`${BASE_URL}/authentication/current`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        })
        .then((res) => {
          const { data } = res.data;
          commit('SET_CURRENT_USER', data);
        })
        .catch(() => {
          commit('APP_INITIALIZING', false);
          dispatch('logout');
        });
    },
    logout({ commit }, navigationCallback) {
      commit('LOGOUT');
      localStorage.clear();
      delete axios.defaults.headers.common['Authorization'];
      if (navigationCallback) {
        navigationCallback();
      }
    },
  },
  mutations: {
    AUTH_REQUEST(state) {
      state.status = 'loading';
    },
    AUTH_SUCCESS(state, token) {
      state.status = 'success';
      state.token = token;
    },
    AUTH_ERROR(state, msg) {
      state.status = 'error';
      state.message = msg;
    },
    LOGOUT(state) {
      state.status = '';
      state.token = '';
    },
    APP_INITIALIZING(state, status) {
      state.initializing = status;
    },
    SET_CURRENT_USER(state, data) {
      (state.initializing = false), (state.currentUser = data);
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    isLoading: (state) => state.status === 'loading',
    currentUser: (state) => state.currentUser,
    token: (state) => state.token,
  },
};
